
const _ = require('lodash');

import ko from 'rgs-knockout';

const template = require('../templates/ko-component-debug-definitions-node.html');


class Model {
	constructor (params) {
		_.extend(this, params);
	}
}


ko.components.register('debug-definitions-node', {
	viewModel: Model,
	template: template(),
});


